import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog-issue',
  templateUrl: './confirm-dialog-issue.component.html',
  styleUrls: ['./confirm-dialog-issue.component.css']
})
export class ConfirmDialogIssueComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogIssueComponent>,
   @Inject(MAT_DIALOG_DATA) public data: { title: string, message: string }
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true); 
  }

  onCancel(): void {
    this.dialogRef.close(false); // user clicked "No"
  }
}
